/**
 * בונה טאב בודד על בסיס הגדרת טאב
 * @param {Object} tabDefinition - הגדרת הטאב מ-buildTabsConfig
 * @param {Object} state - ה-state הנוכחי
 * @param {Object} authState - ה-state של auth
 * @returns {Object|null} - אובייקט טאב מוכן או null אם הטאב לא צריך להיות מוצג
 */
export const buildTabConfig = (tabDefinition, state, authState) => {
  // בודק אם הטאב צריך להיות מוצג
  if (tabDefinition.shouldShow && !tabDefinition.shouldShow(state, authState)) {
    return null;
  }

  // בודק titleOverride - אם קיימת ומחזירה ערך, משתמש בו; אחרת משתמש ב-title
  let title = tabDefinition.title;
  if (tabDefinition.titleOverride) {
    const overrideTitle = tabDefinition.titleOverride(state, authState);
    if (overrideTitle !== null && overrideTitle !== undefined) {
      title = overrideTitle;
    }
  }

  // בונה את ה-sections באמצעות sectionsBuilder
  const rawSections = tabDefinition.sectionsBuilder ? tabDefinition.sectionsBuilder(state, authState) : [];
  const sections = rawSections.filter(section => section.show !== false);

  // מחזיר אובייקט טאב מוכן
  return {
    id: tabDefinition.id,
    title,
    sections,
  };
};

